import React from 'react';
import PropTypes from 'prop-types';

export const LinkAttachment = ({
  text,
  thumb_url,
  title,
  title_link
}) => {
  return <div className="Attachment LinkAttachment flex column">
    {thumb_url && <img className="card-thumbnail" src={thumb_url} alt={title} />}
    <div className="card-content text-xs">
      <a className="card-link heavier" href={title_link} target="_blank" rel="noopener noreferrer">{title}</a>
      {text && <p className="card-text">{text}</p>}
    </div>
  </div>;
};

LinkAttachment.propTypes = {
  text: PropTypes.string,
  thumb_url: PropTypes.string,
  title: PropTypes.string,
  title_link: PropTypes.string
};
